import styled from "styled-components";

const HiddenFileInput = styled.input.attrs({
  type: "file",
})`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap; /* 1 */
  clip-path: inset(50%);
  border: 0;
`;

export default HiddenFileInput;
